// extracted by mini-css-extract-plugin
export default {"info-box":"Dashboard_info-box__T75Au","card":"Dashboard_card__prQLX","card1":"Dashboard_card1__hJWur","card2":"Dashboard_card2__7C+u3","card3":"Dashboard_card3__JBpUf"};